module.exports = __webpack_public_path__ + "assets/img/free_23.23777718.png";